// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';

// utilities
import { get, merge } from 'lodash';

// components
import TextArea from '../../../../common/components/c_TextArea';
import FlatButton from '../../../../common/components/c_FlatButton';
import DropDownMenu from '../../../../common/components/c_DropDownMenu';
import fixLines from '../../../../lib/fixLines';

// get validations
import {getSchema} from '../../../../models/applicantNote';

const validationObj = getSchema();

const dropDownProps = {
  style: {
    height: '45px',
    width: '100%',
    fontSize: '14.5px',
    textTransform: 'none',
    textAlign: 'left'
  },
  labelStyle: {
    padding: 0
  },
  listStyle: {
    width: '260px'
  },
  menuStyle: {
    width: '260px'
  },
  underlineStyle: {
    margin: 0,
    borderTopWidth: '1px'
  },
  iconStyle: {
    right: 0
  }
};

export default class AddNoteForm extends Component {
  static propTypes = {
    applicantId: PropTypes.number.isRequired,
    applicantStatusId: PropTypes.number.isRequired,
    submitNote: PropTypes.func.isRequired,
    category: PropTypes.string.isRequired,
    categories: PropTypes.array,
    color: PropTypes.string.isRequired,
    selectedItem: PropTypes.object,
  }

  state = {
    noteDropDownVal: null, // some statuses will have corresponding dropdowns
    note: get(this.props.selectedItem, 'note'),
    category: get(this.props.selectedItem, 'category', this.props.category),
    errorCount: 0
  }

  onChange(prop, event, value) {
    this.setState(merge({}, this.state, {
      [prop]: value || event.target.value
    }));

  }

  onErrorChange = changeInt => {
    this.setState(merge(this.state, {errorCount: this.state.errorCount + changeInt}));
  };

  onSave() {
    this.props.submitNote({
      applicantId: this.props.applicantId,
      applicantStatusId: this.props.applicantStatusId,
      category: this.state.category,
      color: this.props.color,
      note: fixLines(this.state.note)
    });
    this.clear();
  }

  clear() {
    this.setState(merge({}, {
      noteDropDownVal: null,
      note: ''
    }));
  }

  render() {
    return (
      <form className='event-form notes-form'>
        <DropDownMenu className='type-dropdown note-dropdown'
                      floatingLabelText='Type of Note'
                      floatingLabelStyle={{left: 0, top: '-10px'}}
                      defaultValue={this.state.category}
                      menuItems={this.props.categories}
                      onChange={this.onChange.bind(this, 'category')}
                      data-id='type of note'
                      {...dropDownProps}/>
        <TextArea
          className='note-textarea'
          data-id='Note Text'
          style={{
            minHeight: '160px'
          }}
          onChange={this.onChange.bind(this, 'note')}
          onErrorChange={this.onErrorChange}
          value={this.state.note}
          validation={validationObj.note}
        />
        <FlatButton disabled={!this.state.note || this.state.errorCount > 0}
                    onClick={::this.onSave}
                    className='save-btn'
                    label='Save'
                    data-id='save button'
                    disabledStyle={{
                      color: '#979797',
                      backgroundColor: '#fff'
                    }}
                    labelStyle={{
                      width: 'auto',
                      padding: 0
                    }}/>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/r_Events/c_AddNoteForm/index.js